import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Field } from "formik";
import FormField from "../fields/FormField";
import Label from "../../../atoms/label/Label";
import Tooltip from "../../../atoms/tooltip/Tooltip";
import drupalSettings from "../../../../Helpers/drupalSettings";

const lang = drupalSettings.path.currentLanguage;

class PasswordInput extends React.Component {
  constructor(props) {
    super(props);
    this.detectCaps = this.detectCaps.bind(this);

    this.state = {
      caps: false
    };
  }

  detectCaps(event) {
    return event.getModifierState("CapsLock")
      ? this.setState({ caps: true })
      : this.setState({ caps: false });
  }

  render() {
    const {
      label,
      name,
      classes,
      required,
      tooltip,
      passwordResetLink
    } = this.props;
    const { caps } = this.state;

    return (
      <FormField name={name}>
        <Label text={label} id={name} required={required} />
        {tooltip && <Tooltip text={tooltip} />}
        <Field
          className={classes}
          type="password"
          name={name}
          id={name}
          onKeyDown={this.detectCaps}
        />
        <div className="password-meta">
          {caps ? (
            <span className="icon-attention caps-lock-warning">
              {window.Drupal.t("Caps lock is on")}
            </span>
          ) : (
            <></>
          )}
          {passwordResetLink ? (
            <Link
              className="forgot-password-link"
              to={`/${lang}/my-account/sign-in/forgot-password`}
            >
              {window.Drupal.t("Forgot your password?")}
            </Link>
          ) : (
            <></>
          )}
        </div>
      </FormField>
    );
  }
}

PasswordInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  classes: PropTypes.string,
  required: PropTypes.bool,
  tooltip: PropTypes.string,
  passwordResetLink: PropTypes.bool
};

PasswordInput.defaultProps = {
  classes: "form-item__textfield",
  required: false,
  tooltip: "",
  passwordResetLink: false
};

export default PasswordInput;
